import { Box, FormHelperText } from "@mui/material";
import InputField, { InputFieldProps } from "./InputField";

const REQUIRED_COLOR = "#ff4d4f";

export interface LabeledInputProps extends InputFieldProps {
  label: string;
  required?: boolean;
  helperText?: string;
}

/** InputField with a label above it (for MUI-state forms that don't use antd Form.Item). */
const LabeledInput = ({ label, required, helperText, ...rest }: LabeledInputProps) => (
  <Box>
    <Box component="label" sx={{ display: "block", mb: 0.5, fontSize: "14px" }}>
      {label}
      {required && <span style={{ color: REQUIRED_COLOR }}> *</span>}
    </Box>
    <InputField {...rest} />
    {helperText && <FormHelperText error={rest.error}>{helperText}</FormHelperText>}
  </Box>
);

export default LabeledInput;
